import React from "react";
import { createRoot } from "react-dom/client";
import "./common/styles/main.scss";
import reportWebVitals from "./reportWebVitals";
import { registerSW } from "virtual:pwa-register";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./app/App";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
);

// Register service worker for PWA functionality
const updateSW = registerSW({
    onNeedRefresh() {
        if (confirm("New content available, reload?")) {
            updateSW(true);
        }
    },

    onOfflineReady() {
        console.log("App ready to work offline");
    },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
